import type { Coordinate, Int } from "@/types";

import {
  MapInteractive,
  parseLatLngString,
  createMapMarker,
} from "@/modules/map";

export type PositionGpsProps = {
  contextId: Int;
  coordinate: Coordinate;
};

const PositionGps = ({ contextId, coordinate }: PositionGpsProps) => {
  const mapCoordinates = parseLatLngString({ coordinate });
  const currentMarker = createMapMarker({
    key: `position_gps_${contextId}`,
    position: mapCoordinates,
  });

  return (
    <MapInteractive
      id={`position_gps_${contextId}`}
      markers={currentMarker ? [currentMarker] : []}
      sizes={{ ratio: "16:9" }}
      noInfoWindow
    />
  );
};

export default PositionGps;
